import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    window.addEventListener("load", () => this.print(), { once: true })
  }

  print() {
    window.print()
  }
}
